import { CourierOrdersComponent } from './courier-orders.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'order/:id',
    data: { breadcrumb: 'Overview' },
    component: CourierOrdersComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CourierOrdersRoutingModule {}
